module.exports = __webpack_public_path__ + "static/media/university-early-entry-srs.fa986b21.jpg";